<template>
  <div>
    <template v-if="usar_tela_descanso">
      <v-img
        v-if="!tela_descanso_ativa"
        width="100vw"
        height="100vh"
        src="@/assets/capa_padrao.png"
      />
      <v-img
        v-else
        contain
        width="100vw"
        height="100vh"
        :src="tela_descanso_ativa.url_midia"
      />
    </template>
    <template v-else>
      <section
        class="wrapper"
        :style="{
          'background-color': configMosaico?.dscCorBackground,
          'background-image': `url(${configMosaico?.urlImgBackground})`,
          'background-size': 'cover',
        }"
      >
        <v-container class="mosaico-container mb-0">
          <v-icon v-if="isMosaicoLoading" class="mr-2 rotate loading-wrapper" x-large
            >mdi-loading</v-icon
          >
          <section>
            <v-row class="ma-0 justify-center mosaico-galeria-wrapper">
              <div v-if="cameras" class="grid-wrapper">
                <div
                  v-for="(camera, index) in cameras.items.filter(
                    (c) => c.camera.status === 'STREAMING'
                  )"
                  :key="camera.camera.id"
                  class="fade-animation"
                  :style="`animation-duration:${(index + 1) * 200}ms`"
                  @click="selectCamera(camera)"
                >
                  <CardCameraMosaico
                    :camera-data="camera.camera"
                    :card-config="configCard"
                  />
                </div>
              </div>
            </v-row>
          </section>
        </v-container>
        <div
          class="blur-wrapper"
          :style="isCardMosaicoVisible ? 'display: block' : 'display:none'"
          v-on:click="close($event)"
        >
          <div v-if="selectedCamera" class="expanded-card-wrapper mx-auto my-5">
            <CardCameraMosaico
              :camera-data="selectedCamera.camera"
              :card-config="configCard"
              :fullscreen="isCardMosaicoVisible"
              @played="setPlayerRef"
            />
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import CardCameraMosaico from "@/components/Cards/Cameras/CardCameraMosaico.vue";
import { apiClient } from "../services/api";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    CardCameraMosaico,
  },
  data() {
    return {
      producao: {},
      isCardMosaicoVisible: false,
      selectedContent: {},
      isMosaicoLoading: false,
      selectedCamera: null,
      playerRef: undefined,
      configCard: {},
    };
  },
  async beforeMount() {
    if (!this.$store.state.users.isAuthenticated) {
      apiClient.interceptors.request.use(
        (config) => {
          const token = this.$route.query.token || null;

          if (token) {
            config.headers["x-access-token"] = token;
          }
          return config;
        },
        (error) => {
          console.error(error);
          return Promise.reject(error);
        }
      );
    }

    setInterval(async () => {
      await this.getProducaoData();
    }, 3000);
    if (
      JSON.parse(localStorage.getItem("@socialcam/selected_option_production")) == null &&
      this.$route.query.cod_producao == null
    ) {
      this.$router.push({ name: "login" });
      return;
    }
    this.isMosaicoLoading = true;
    this.configCard = this.configMosaico
      ? {
          dscCorCard: this.configMosaico?.dscCorCard,
          dscCorFonte: this.configMosaico?.dscCorFonte,
        }
      : null;

    this.fetchMosaicoData().then(() => {
      this.isMosaicoLoading = false;
    });
    this.fetchTelaDescansoAtiva({ cod_producao: this.cod_producao });
    this.getPreferenciasMosaico({ cod_producao: this.cod_producao });

    setInterval(() => {
      this.fetchMosaicoData();
      this.fetchTelaDescansoAtiva({ cod_producao: this.cod_producao });

      this.getPreferenciasMosaico({ cod_producao: this.cod_producao });
    }, 5000);
  },
  computed: {
    ...mapGetters({
      tela_descanso_ativa: "telas_descanso/getTelaDescansoAtiva",
      tipoMosaico: "mosaico/getOrientacaoSelecionada",
      configMosaico: "mosaico/getConfigSelecionada",
      cameras: "cameras/getterCamerasEmExibicao",
    }),
    cod_producao() {
      return (
        JSON.parse(localStorage.getItem("@socialcam/selected_option_production")) ||
        parseInt(this.$route.query.cod_producao) ||
        null
      );
    },
    usar_tela_descanso() {
      if (this.producao) {
        const val = this.producao.settings?.mosaico?.usar_tela_descanso ?? false;
        localStorage.setItem("@socialcam/usar_tela_descanso", val);
        return val;
      }
      localStorage.setItem("@socialcam/usar_tela_descanso", false);
      return false;
    },
    flg_exibir_uf() {
      if (this.producao) {
        const val = this.producao.settings?.mosaico?.exibir_uf ?? true;
        localStorage.setItem("@socialcam/exibir_uf_mosaico", val);
        return val;
      }
      localStorage.setItem("@socialcam/exibir_uf_mosaico", true);
      return true;
    },
  },
  methods: {
    ...mapActions({
      fetchTelaDescansoAtiva: "telas_descanso/getTelaDescansoAtiva",
      getPreferenciasMosaico: "mosaico/getPreferenciasMosaico",
      getCamerasModeradas: "cameras/getCamerasModeradas",
    }),
    setPlayerRef(ref) {
      this.playerRef = ref;
    },
    async getProducaoData() {
      await apiClient.get(`listarDadosProducao/${this.cod_producao}`).then((response) => {
        this.producao = response.data.producao;
      });
    },
    async fetchMosaicoData() {
      if (this.cod_producao) {
        await this.getCamerasModeradas({
          cod_producao: this.cod_producao,
          filtro_texto: "",
          page: 1,
          size: 100,
        });
      }
    },
    selectCamera(camera) {
      this.selectedCamera = camera;
      this.changeVisible();
    },
    changeVisible() {
      this.isCardMosaicoVisible = !this.isCardMosaicoVisible;
    },
    close(event) {
      const targetClass = event.target.className.toLowerCase();
      if (
        targetClass.includes("blur-wrapper") ||
        targetClass.includes("expanded-card-wrapper")
      ) {
        if (this.playerRef) {
          this.playerRef.pause();
          this.playerRef = undefined;
        }
        this.selectedCamera = null;
        this.changeVisible();
      }
    },
  },
  watch: {
    configMosaico: function (newVal) {
      this.configCard = newVal
        ? { dscCorCard: newVal?.dscCorCard, dscCorFonte: newVal?.dscCorFonte }
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  max-height: 100%;
  height: 100vh;
  margin: auto;
}

.loading-wrapper {
  position: fixed;
  top: 50%;
  right: 50%;
}

.mosaico-container {
  margin: 0;
  max-width: 100%;
  max-height: 100%;
  overflow-y: auto;
  margin-bottom: 25px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.rotate {
  animation: spin 2s linear infinite;
}

.mosaico-galeria-wrapper {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.grid-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  grid-auto-flow: dense;
  grid-auto-rows: minmax(200px, auto);

  @media (min-width: 62.5rem) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 93rem) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 125rem) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 156rem) {
    grid-template-columns: repeat(5, 1fr);
  }
}

@keyframes easyIn {
  0% {
    opacity: 0;
    transform: scale(0.1);
  }

  100% {
    opacity: 0.9;
    transform: scale(1);
  }
}

.fade-animation {
  animation-name: easyIn;
}

.blur-wrapper {
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(8px);
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  z-index: 1;
}

.expanded-card-wrapper {
  height: 95%;
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  background-color: transparent;
  box-shadow: none !important;

  @media screen and (max-width: 600px) {
    width: 90%;
  }
}
</style>
